<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">汇率设置 </div>
      
      
      <el-form-item label="是否开启人民币转美元汇率" prop="is_coupon">
        <el-switch v-model="form.is_open"
        active-text="启用" inactive-text="关闭" 
            :active-value="1" :inactive-value="0"
        ></el-switch>
      </el-form-item>
    
      <el-form-item label="AccessKey">
        <el-input v-model="form.AccessKeyId" class="max-w460"></el-input>
        <el-link  :underline="false" href="https://www.tanshuapi.com//" target="_blank"
            type="primary">汇率API申请地址</el-link>
             
      </el-form-item>


      <el-form-item label="人民币-美元实时汇率">
        <el-input v-model="form.ss_ed" class="max-w460"></el-input>
        <el-link  :underline="false" @click='clickGet'
        type="primary">点击获取</el-link>
             
        <div>每日2点整会获取当天汇率</div>
      </el-form-item>



  
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          AccessKeyId: '',
          AccessKeySecret: '',
          ss_ed:"",
          is_open:0
        },
        w7:{},
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      clickGet(){
        var self = this;
        SettingApi.getExchangeRate({}, true)
          .then(data => {
           setTimeout(() => {
            self.getData();
           }, 500);
          })
          .catch(error => {});
      },
      getData() {
        let self = this;
        SettingApi.exchangeRateDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.AccessKeyId = vars.AccessKeyId;
            self.form.ss_ed = vars.ss_ed
            self.form.is_open = vars.is_open;
          })
          .catch(error => {});

      },


      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.editExchangeRate(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      //发送短信
      sendOut() {
        let self = this;
        let params = this.form;
        SettingApi.sendTranslate(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你,发送成功',
              type: 'success'
            });
            self.$router.push('/setting/Sms');

          })
          .catch(error => {

          });
      }



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/exchange_rate/index.vue